import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './ClientApplicationDetailLayout.resolver';
import ClientApplicationDetailLayout from './ClientApplicationDetailLayout';

export default async(resolver, { context: RootStoreContext })(
  ClientApplicationDetailLayout
);
